import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import React from "react";
var useThrotledAsyncCallback = function useThrotledAsyncCallback(callback) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var timeoutID = React.useRef();
  var newCallback = React.useCallback(function (timeout) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    if (timeoutID.current) {
      clearTimeout(timeoutID.current);
    }
    timeoutID.current = _setTimeout(function () {
      timeoutID.current = null;
      callback.apply(void 0, rest);
    }, timeout);
  }, dependencies);
  React.useEffect(function () {
    return function () {
      clearTimeout(timeoutID.current);
    };
  }, []);
  return newCallback;
};
export default useThrotledAsyncCallback;